import { render, staticRenderFns } from "./setUphuanjing.vue?vue&type=template&id=5ac8de39&scoped=true&"
import script from "./setUphuanjing.vue?vue&type=script&lang=js&"
export * from "./setUphuanjing.vue?vue&type=script&lang=js&"
import style0 from "./setUphuanjing.vue?vue&type=style&index=0&id=5ac8de39&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac8de39",
  null
  
)

export default component.exports